// extracted by mini-css-extract-plugin
export default {"windowLocation":"map_windowLocation__b8j0U","address":"map_address__UFG8O"};